//
// Pin.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./LocationFeature";
import "../map/MapPinType";

var Pin = createModule("gtl::Pin", ["gtl::LocationFeature"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getType: [4],
    },
    ,
    ,
]);
export default Pin;
